const SDK_VERSION = '0.1.11'

export default SDK_VERSION

